export default __webpack_public_path__ + "static/media/HowScalyrWorks.cd058d96.md";